/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as a from "react";
import e from "prop-types";
import { classNames as g, uFloatingLabel as N } from "@progress/kendo-react-common";
import { useLocalization as B } from "@progress/kendo-react-intl";
import { labelsOptional as y, messages as D } from "./messages/index.mjs";
const I = (l) => {
  const [o, i] = a.useState({
    focused: !1
  }), h = (v) => {
    i({ focused: !0 });
  }, E = (v) => {
    i({ focused: !1 });
  }, {
    label: s,
    editorId: n,
    className: F,
    labelClassName: L,
    editorValue: r,
    editorPlaceholder: C,
    editorValid: S,
    editorDisabled: c,
    style: V,
    id: d,
    optional: z,
    unstyled: m,
    ...O
  } = l, P = B(), b = z ? P.toLanguageString(y, D[y]) : "", u = b && /* @__PURE__ */ a.createElement("span", { className: "k-label-optional" }, b), p = m && m.uFloatingLabel, t = !C && !r && r !== 0, T = g(
    N.wrapper({
      c: p,
      focused: o.focused,
      empty: t,
      notEmpty: !t,
      disabled: c,
      isRtl: l.dir === "rtl"
    }),
    F
  ), f = g(
    N.label({
      c: p,
      focused: o.focused,
      empty: t,
      notEmpty: !t,
      invalid: S === !1,
      disabled: c
    }),
    L
  );
  return /* @__PURE__ */ a.createElement(
    "span",
    {
      ...O,
      id: l.id,
      className: T,
      onFocus: h,
      onBlur: E,
      style: V,
      dir: l.dir
    },
    l.children,
    s ? n ? /* @__PURE__ */ a.createElement("label", { id: d, htmlFor: n, className: f }, s, u) : /* @__PURE__ */ a.createElement("span", { id: d, className: f }, s, u) : null
  );
};
I.propTypes = {
  label: e.string,
  editorId: e.string,
  editorValue: e.oneOfType([e.string, e.bool, e.number]),
  editorPlaceholder: e.string,
  editorValid: e.bool,
  editorDisabled: e.bool,
  id: e.string,
  style: e.object,
  className: e.string,
  labelClassName: e.string,
  optional: e.bool
};
export {
  I as FloatingLabel
};
